const MIN_YEAR = 1900
const MAX_YEAR = 2099

export {
  MIN_YEAR,
  MAX_YEAR
}
